var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('honjo-section',{attrs:{"title":"标题","subtitle":"辅助标题"}},[_c('p',[_vm._v("第一个例子")]),_c('p',[_vm._v("标准开发")]),_c('p',[_vm._v("兼容性")]),_c('p',[_vm._v("自行构建")]),_c('p',[_vm._v("自行构建")]),_c('p',[_vm._v("按需加载")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }